module.exports = __webpack_public_path__ + "img/TN.b67b898a.png";